import { ColumnStore, FieldFilterPicker, DateHelper } from "@bryntum/schedulerpro";

const assignIdToItems = (items) => items.map((item, idx) => ({ ...item, pathIdx: idx }));

export const getSorters = (sorters) => assignIdToItems(sorters).filter((sorter) => !sorter.hidden);

export const getFilters = (filters) => assignIdToItems(filters).filter((filter) => (!filter.hidden && (filter.property || filter.value)));

export const getGroupers = (groupers) => assignIdToItems(groupers);

// Helper function to get filter value display
// The filter value can be of combo field value, in that case we need to retrieve the value from the relevant store.
export const getFilterValue = (filterItem) => {
  if (!filterItem.value) {
    // Look up this filter among operators
    const filter = FieldFilterPicker.defaultOperators[filterItem.type]?.find((f) => f.value === filterItem.operator);

    // Filter should always be found, because that's what we normally pick from the filter combo
    if (filter) {
      return FieldFilterPicker.L(filter.text);
    }
    else {
      console.warn("Cannot resolve value for a filter");
      return "";
    }
  }

  if (filterItem.type === "date" && filterItem.value) {
    return DateHelper.format(filterItem.value, "YYYY-MM-DD");
  }

  return filterItem.value;
};

// Helper function to get column name from field
// Most of the columns defined in column config doesn't have `text` property instead that's defined in column custom definition
// We're getting column text from column definition in case column didn't have text defined
export const getColumnNameByField = (gridColumns, field) => {
  // field can be nested property such as budget.accountingNumber in this case we need to
  const nestedFieldValue = field && field.includes(".") ? field.split(".")[1] : field;
  // still we need to check first with default field value and then with nestedFieldValue as some grid may support nested one's
  const column = gridColumns.find((column) => column.field === field || column.field === nestedFieldValue);

  if (column) {
    if (column.text) {
      return column.text;
    } else if (column.type) {
      return ColumnStore.getColumnClass(column.type)?.defaults?.text;
    }
  } else {
    const columnByDefinition = gridColumns.find((column) => {
      if (column.type) {
        const columnDefinition = ColumnStore.getColumnClass(column.type);
        return columnDefinition?.defaults?.field === field;
      }
    });
    if (columnByDefinition) {
      return ColumnStore.getColumnClass(columnByDefinition.type)?.defaults?.text;
    }
  }
  return field;
};
